import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const TextoCatequesis = () => {
  return (
    <section
      className="py-5 position-relative"
      style={{
        background: "linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%)",
        color: "#212529",
        fontFamily: "'Merriweather', serif",
      }}
    >
      <div className="container text-center">
        {/* Línea decorativa superior */}
        <div
          className="mx-auto mb-4"
          style={{
            width: "60px",
            height: "4px",
            backgroundColor: "#bfa046", // dorado suave
            borderRadius: "2px",
          }}
        ></div>

        <h2 className="display-5 fw-semibold text-success mb-4">
          Pastoral y Vida de Fe
        </h2>

        <div id="textoCatequesis" className="col-lg-10 mx-auto">
          <p className="lead mb-4">
            Acompañamos a nuestros estudiantes en su camino de fe, ofreciendo un
            espacio de encuentro profundo con Dios que favorece la reflexión
            personal y el crecimiento espiritual. Buscamos que cada niño y joven
            descubra el sentido trascendente de su vida, guiado por los valores
            del Evangelio y la enseñanza cristiana que dan fundamento a la
            comunidad educativa.
          </p>

          <p className="lead mb-4">
            Promovemos una vivencia auténtica y alegre de la espiritualidad a
            través de celebraciones litúrgicas significativas, momentos de
            oración compartida, convivencias, talleres y experiencias pastorales
            que fortalecen la unión, el compromiso y la esperanza.
          </p>

          <p className="lead">
            Nuestra misión es formar corazones solidarios, comprometidos con el
            servicio al prójimo y con la construcción de un mundo más justo y
            fraterno. De este modo, cada actividad se convierte en una
            oportunidad para vivir la fe de manera concreta, integrando la
            palabra, la acción y el testimonio cristiano en la vida cotidiana de
            toda la comunidad educativa.
          </p>
        </div>

        {/* Línea decorativa inferior */}
        <div
          className="mx-auto mt-5"
          style={{
            width: "60px",
            height: "4px",
            backgroundColor: "#bfa046",
            borderRadius: "2px",
          }}
        ></div>
      </div>

      {/* Luz decorativa de fondo */}
      <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          background:
            "radial-gradient(circle at center, rgba(255,255,200,0.3) 0%, transparent 70%)",
          zIndex: -1,
        }}
      ></div>
    </section>
  );
};

export default TextoCatequesis;
